import { createSelector } from 'reselect';

import { __ } from '../../../../i18n/l10n';
import { GetIsLoadingFromPropsType, getIsLoadingFromProps } from '../../../../selectors/_propsGetters_';
import { StateType } from '../../../../states';
import { getGRLabelsBySkinId } from '../../constants/labels';
import { selectGRGlobalSkinId, selectGRGlobalStatus } from '../../selectors/global/globalPrimary.selector';
import { GRGlobalStatuses, GRSkinIds } from '../../types/global';

const emptyArray: [] = [];

const selectIsEnrollmentDisabled = (state: StateType, props: GetIsLoadingFromPropsType) => {
  const { isLoading } = props;
  const globalStatus = selectGRGlobalStatus(state);
  return globalStatus === GRGlobalStatuses.ENDING || isLoading;
};

const selectRoundDescriptions = createSelector([selectGRGlobalSkinId], (skinId) => {
  if (skinId === GRSkinIds.GIFT_RACE) {
    return [
      __('The Pegasus shoes to fly over your next match'),
      __('The remote-controlled ball with its unpredictable trajectories'),
      __('The chameleon jersey to change teams in a flash'),
    ];
  }

  return emptyArray;
});

const selectMainDescription = (state: StateType) => {
  const skinId = selectGRGlobalSkinId(state);
  return getGRLabelsBySkinId(skinId)?.Enrollment.mainDescription;
};

const selectGREnrollmentProps = createSelector(
  [
    selectIsEnrollmentDisabled,
    selectGRGlobalSkinId,
    selectRoundDescriptions,
    selectMainDescription,
    getIsLoadingFromProps,
  ],
  (isEnrollmentDisabled, skinId, roundDescriptions, mainDescription, isLoading) => ({
    isEnrollmentDisabled,
    skinId,
    roundDescriptions,
    mainDescription,
    isLoading,
  }),
);

export default selectGREnrollmentProps;
